var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.cssProps)},[_c('loading',{ref:"loading",attrs:{"fixed":""}},[_c('v-layout',[_c('router-view',{staticClass:"router-view"}),_c('alert',{ref:"alert"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }